// extracted by mini-css-extract-plugin
module.exports = {"HeroCategorySimpleTitle":"styles_HeroCategorySimpleTitle__SFTRM","title":"styles_title__4TpNu"};